import useUserVerificationLevels from '@/hooks/useUserVerificationLevels/useUserVerificationLevels';
import React, { useState } from 'react';
import ModalWrapper from '../ModalWrapper/ModalWrapper';
import EmailVerification from '@/features/Onboarding/components/Steps/EmailVerification/EmailVerification';
import VerificationLevel1 from '@/features/Onboarding/components/Steps/VerificationLevel1/VerificationLevel1';
import { icons } from '@/Icons';
import ds from '@/styles/ds/ds.module.scss';
import { useModalStatus } from '@privy-io/react-auth';
import { useModalStoreActions } from '@/store';

const VerificationModalSteps = () => {
	const {
		isEmail_verified,
		isVerified_level_1,
		isVerified_level_2,
		isVerified_level_3,
	} = useUserVerificationLevels();
	const [beginVerificationFlow, setBeginVerificationFlow] = useState(false);

	const handleClose = () => {
		const url = new URL(window.location.href);
		// url.searchParams.delete('wallet');
		// router.push(url.pathname + url.search);
		// setModalStatus(null);
	};

	// if (!beginVerificationFlow) {
	// 	return (
	// 		<ModalWrapper onClose={handleClose}>
	// 			<div className="relative bg-red-500 w-screen max-w-[600px] h-[100svh] top-0 m-auto md:h-fit max-h-[750px] px-4 py-8 md:p-8  md:m-auto flex rounded-[10px] flex-col gap-5 popup overflow-hidden  ">
	// 				<EmailVerification />
	// 			</div>
	// 		</ModalWrapper>
	// 	);
	// }

	if (!isEmail_verified) {
		return (
			<ModalWrapper onClose={handleClose}>
				<div className="relative  bg-midnight-blue w-screen max-w-[600px] h-[100svh] top-0 m-auto md:h-fit max-h-[750px] px-4 py-8 md:p-8  md:m-auto flex rounded-[10px] flex-col gap-5 popup overflow-hidden rel  ">
					<CloseButton />
					<EmailVerification />
				</div>
			</ModalWrapper>
		);
	}
	if (!isVerified_level_1) {
		return (
			<ModalWrapper onClose={handleClose}>
				<div className="relative bg-midnight-blue w-screen max-w-[600px] h-[100svh] top-0 m-auto md:h-fit max-h-[750px] px-4 py-8 md:p-8  md:m-auto flex rounded-[10px] flex-col gap-5 popup overflow-hidden  ">
					<CloseButton />
					<p className={`${ds.sectionHeader} flex items-center gap-3`}>
						<span className="w-6 h-6 relative text-dove-white-o-70 ">
							<icons.verification />
						</span>
						Verify Level 1
					</p>
					<VerificationLevel1 isInModal={true} />
				</div>
			</ModalWrapper>
		);
	}
	return null;
};

export default VerificationModalSteps;

const CloseButton = () => {
	const { setModalStatus } = useModalStoreActions();
	return (
		<button
			onClick={() => {
				setModalStatus(null);
			}}
			className=" top-8 right-8  text-xl font-bold z-10 w-fit  absolute"
			aria-label="Close wallet modal"
		>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="18"
				height="18"
				viewBox="0 0 18 18"
				fill="none"
			>
				<path
					d="M16.4566 3.19978C16.9147 2.74167 16.9147 2.00091 16.4566 1.54767C15.9985 1.09444 15.2577 1.08957 14.8045 1.54767L9.00507 7.34711L3.20076 1.5428C2.74265 1.08469 2.00188 1.08469 1.54865 1.5428C1.09542 2.00091 1.09054 2.74167 1.54865 3.19491L7.34809 8.99434L1.54378 14.7987C1.08567 15.2568 1.08567 15.9975 1.54378 16.4508C2.00188 16.904 2.74265 16.9089 3.19588 16.4508L8.99532 10.6513L14.7996 16.4556C15.2577 16.9137 15.9985 16.9137 16.4517 16.4556C16.905 15.9975 16.9098 15.2568 16.4517 14.8035L10.6523 9.00409L16.4566 3.19978Z"
					fill="#F2F3F5"
					opacity={0.3}
				/>
			</svg>
		</button>
	);
};
